import React, { memo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { PopoverText } from '../../common/parts/PopoverText';

import { confirmState } from '../../../store/confirmState';
import { orderState } from '../../../store/orderState';

export const FormrNote = memo((props) => {
  const isConfirm = useRecoilValue(confirmState);
  const [orderData, setOrderData] = useRecoilState(orderState);

  const onChangeNote = (e) => {
    setOrderData({...orderData, requestnote: e.target.value});
  }

  return (
    <>
      <p className="h3">その他、備考 
        <PopoverText textTitle="その他、備考" textBody="オプションやお知らせ事項をご記入ください" />
      </p>
      <div className="card mb-5">
        <div className="card-body">
          <textarea className="form-control" id="exampleFormControlTextarea1" rows="5" placeholder="オプションに関する補足や、その他お知らせされたいことをご記入ください" onChange={onChangeNote} disabled={isConfirm} value={orderData.requestnote}></textarea>
        </div>
      </div>
    </>
  );
});